import { api } from 'app/utils/api/helpers'

/**
 * Submit tenancy transfer request
 * @param {string} teamGUID - The team GUID
 * @param {object} transferData - The tenancy transfer data
 * @returns {Promise<object>} - The API response
 */
export const submitTenancyTransfer = async (teamGUID, transferData) => {
  if (!teamGUID) {
    throw new Error('Team GUID is required')
  }

  // Transform the data to match the API expectations
  const payload = {
    unitNumber: transferData.unitNumber || undefined,
    streetNumber: transferData.streetNumber,
    streetName: transferData.streetName,
    suburb: transferData.suburb,
    state: transferData.state,
    postcode: transferData.postcode,
    leaseStartDate: transferData.leaseStartDate,
    weeklyRent: parseInt(transferData.weeklyRent, 10),
    email: transferData.email,
    mobile: transferData.mobile,
    firstName:
      transferData.firstName && transferData.firstName.trim()
        ? transferData.firstName.trim()
        : undefined,
    lastName:
      transferData.lastName && transferData.lastName.trim()
        ? transferData.lastName.trim()
        : undefined,
    message: transferData.message || undefined,
  }

  // Remove undefined values from payload
  Object.keys(payload).forEach((key) => {
    if (payload[key] === undefined) {
      delete payload[key]
    }
  })

  const response = await api.post(
    `/sm/team/${teamGUID}/tenanttransfer`,
    payload,
  )
  return response.data
}
